// extracted by mini-css-extract-plugin
export default {"AnimatedAnnotationIcon":"AnnotationIcon-module__AnimatedAnnotationIcon--rXSEJ","fadeIn":"AnnotationIcon-module__fadeIn--HmaxH"};